<template>
   <div id="ContainerClaim">
      <div class="row page-height"> 
        <div class="col-12">
            <MdTitleRegInfo
               v-bind:RegistrationInfo="PatientTitle" 
               v-bind:titlePrefix="this.Mode ? $t('PatientClaimList.PatientClaimEdit'): $t('PatientClaimList.PatientClaimAdd')" 
               v-bind:IsClinical="false"
               v-bind:titleRef="'titleElementPatientClaim'"
               v-bind:patientCode="this.$route.params.id">
            </MdTitleRegInfo>
      
            <div class="alert alert-fill-warning d-flex align-items-center m-3" role="alert" v-if="isReadOnly">
               <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
               <div class="flex-grow-1">
                  <span>{{ $t('Shared.ReadOnlyPermission') }}</span>
               </div>
            </div>   
            
            

        <div class="IncidentContainerBox noNum mt-2">            
            <div class="row">
            <div class="col-md-12">
                <div class="grid-margin stretch-card">
                <div class="card activeCard">
                    <div class="card-body">
                    <div 
                        class="d-flex align-items-start justify-content-between">
                        <h6 v-b-toggle="'InfoBoxs'" class="card-title flex-grow lower-line text-truncate">
                          {{ $t('PatientClaimList.AditionalInformation') }}
                        </h6>
                        </div>
                        <b-collapse visible id="InfoBoxs" class="small-info ml-2"><small>{{$t('modalMarsMed.clickTitleTextPatient')}}</small></b-collapse>
                    <b-collapse id="InfoBoxs"> 
                        


                        <div class="card activeCard">			
                            <div class="container-mars">
                                <div class="card-container">
                                    <div class="card-body">
                                        <div class="row patPhoto-container">
                                            
                                            <div class="col-md-12">
                                                <div class="row">
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('Patient.Emergency') }}</small><br>
                                                        <b>{{patient.emergency ? 'YES':'NO'}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('PatientClaimList.ReleaseTo1ST') }}</small><br>
                                                        <b>{{patient.infoRelease === 'Y' ? "YES":"NO"}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('PatientClaimList.AcctAssigment') }}</small><br>
                                                        <b>{{patient.acceptAssign === 'Y' ? 'Yes': 'NO'}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('Patient.Deceased') }}</small><br>
                                                        <b>{{patient.deceased === 'Y' ? 'YES':'NO'}}</b>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('PatientClaimList.AmtBillet') }}</small><br>
                                                        <b>{{Info.AmtBillet}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{$t('PatientClaimList.AmtPay')}}</small><br>
                                                        <b>{{Info.AmtPay}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{$t('PatientClaimList.Balance')}}</small><br>
                                                        <b>{{Info.Balance}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{$tc('PatientClaimList.AssignDate')}}</small><br>
                                                        <b>{{patient.sgDate}}</b>
                                                    </div>                                                    
                                                </div>


                                                  <div class="row">
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{ $t('PatientClaimList.RelToEmployment') }}</small><br>
                                                        <b>{{patient.relatedToEmp ? 'YES' : 'NO'}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{$t('PatientClaimList.RelatedToAutoAccident')}}</small><br>
                                                        <b>{{patient.relatedToAuto ? 'YES' : 'NO'}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{$t('Shared.State')}}</small><br>
                                                        <b>{{patient.accState}}</b>
                                                    </div>
                                                    <div class="col-md-3 text-muted p-item">
                                                        <small>{{$tc('PatientClaimList.AccidentDate')}}</small><br>
                                                        <b>{{patient.consultDate}}</b>
                                                    </div>                                                    
                                                </div>


                                            </div>
                                        </div>                   
                                    </div>
                                </div>
                            </div>    
                        </div>
                                       
                </b-collapse>
                    </div> 
                </div>                
                </div>                 
            </div>                     
            </div>                
        </div>

        <b-row>
        <b-col lg="3" md="3" sm="12">
            <MdEdit 
                v-bind:Label="$t('Shared.datefrom')"                      
                v-bind:TypeProp="'date'" 
                v-bind:Min="'1900-01-01'"              
                v-bind:Max="'2200-12-31'"  
                v-bind:isReadOnly="isReadOnly"             
                v-bind:Name="'DateFrom'"
                ref="DateFrom"                        
                v-model="DateFrom"/>          
        </b-col>
        <b-col lg="3" md="3" sm="12">
            <MdEdit 
                v-bind:Label="$t('Shared.dateTo')"                      
                v-bind:TypeProp="'date'"               
                v-bind:Min="'1900-01-01'"
                v-bind:Max="'2200-12-31'"                 
                v-bind:Name="'DateTo'" 
                v-bind:isReadOnly="isReadOnly"
                ref="DateTo"                     
                v-model="DateTo"/>  
        </b-col>

        <b-col lg="3" md="3" sm="12">
            <MdLookup
                v-bind:ModelCode="Claim.DocInd"
                v-bind:ModelDescription="DocIndDescription"
                v-bind:Label="$t('PatientClaimList.DocInd')"
                v-bind:RefCode="'Building'"                     
                v-bind:Api="'Buildings'"
                v-bind:FieldCode="'code'"                    
                v-bind:FieldDescription="'name'"
                :IsDisabled="isReadOnly"    
                :SearchTitle="$t('Shared.Building')"
                :GetValues="onCodeConditionOk"               
                :InvalidFeedback="$t('building.BuildCodeRequired')"
                :SearchFieldCode="'code'"/>
        </b-col> 
         <b-col lg="3" md="3" sm="12">
            <MdLookup
                v-bind:ModelCode="Claim.posCode"
                v-bind:ModelDescription="PosDescription"
                v-bind:Label="$t('PatientClaimList.Pos')"
                v-bind:RefCode="'PlaceOfServices'"                     
                v-bind:Api="'PlaceOfServices'"
                v-bind:FieldCode="'code'"                    
                v-bind:FieldDescription="'description'"
                :IsDisabled="isReadOnly"    
                :SearchTitle="$t('PatientClaimList.Pos')"
                :GetValues="onCodeConditionOk" 
                :SearchFieldCode="'code'"/>
         </b-col>
    </b-row>

    <b-row>         
        
          <b-col lg="3" md="3" sm="12">
            <MdLookup
                v-bind:ModelCode="Claim.SuperBill"
                v-bind:ModelDescription="SuperBillDescription"
                v-bind:Label="$t('PatientClaimList.SuperBill')"
                v-bind:RefCode="'SuperBills'"                     
                v-bind:Api="'SuperBills'"
                v-bind:FieldCode="'code'"                    
                v-bind:FieldDescription="'description'"
                :IsDisabled="isReadOnly"    
                :SearchTitle="$t('PatientClaimList.SuperBill')"
                :GetValues="onCodeConditionOk" 
                :SearchFieldCode="'code'"/>
         </b-col>
         <b-col lg="3" md="3" sm="12">
            <MdLookup
                v-bind:ModelCode="Claim.CPTREVCode"
                v-bind:ModelDescription="CPTREVCODEDescription"
                v-bind:Label="$t('PatientClaimList.CPTREVCODE')"
                v-bind:RefCode="'CPTs'"                     
                v-bind:Api="'CPTs'"
                v-bind:FieldCode="'code'"                    
                v-bind:FieldDescription="'name'"
                :IsDisabled="isReadOnly"   
                :GetValues="onCodeConditionOk" 
                :SearchFieldCode="'code'"/>
         </b-col>
         <b-col lg="3" md="3" sm="12">
            <MdLookup
                v-bind:ModelCode="Claim.hcpcsCode"
                v-bind:ModelDescription="HCPCSDescription"
                v-bind:Label="$t('PatientClaimList.HCPCS')"
                v-bind:RefCode="'HCPCS'"                     
                v-bind:Api="'CPTs'"
                v-bind:FieldCode="'code'"                    
                v-bind:FieldDescription="'name'"
                :IsDisabled="isReadOnly" 
                :GetValues="onCodeConditionOk" 
                :SearchFieldCode="'code'"/>
         </b-col>
          <b-col lg="3" md="3" sm="12">
           <!-- <MdLookup
                v-bind:ModelCode="Claim.DiagCode"
                v-bind:ModelDescription="DiagDescription"
                v-bind:Label="$t('PatientClaimList.DiagCode')"
                v-bind:RefCode="'VisitDiagnosisCodes'"                     
                v-bind:Api=""
                v-bind:FieldCode="'code'"                    
                v-bind:FieldDescription="'name'"
                :IsDisabled="isReadOnly"
                :GetValues="onCodeConditionOk" 
                :SearchFieldCode="'code'"/>-->
                <MdSelect
                    v-bind:Label="$t('PatientClaimList.DiagCode')"             
                    v-bind:Options="DiagList"
                    v-bind:FieldDescription="'description'"
                    v-bind:FieldCode="'code'"
                    v-bind:Model="Claim.DiagCode"                       
                    v-bind:Multiple="false"
                    v-bind:IsDisabled="isReadOnly"
                    :Input="ChangeDropDownDiag"/>
         </b-col>
    </b-row>

    <b-row>
        
         <b-col lg="3" md="3" sm="12">
             <MdEdit 
                  v-bind:Label="$t('PatientClaimList.Day')"
                  v-bind:TypeProp="'text'" 
                  v-bind:Name="'Name'"  
                  v-bind:MaxLengthProp="32"  
                  v-model="Claim.Day"
                  v-bind:isReadOnly="isReadOnly"
                  v-bind:Id="'input_r_nameDay'">                                     
               </MdEdit>
         </b-col>
          <b-col lg="3" md="3" sm="12">
             <MdEdit 
                  v-bind:Label="$t('PatientClaimList.Unit')"
                  v-bind:TypeProp="'text'" 
                  v-bind:Name="'Name'"  
                  v-bind:MaxLengthProp="32"  
                  v-model="Claim.dayUnit"
                  v-bind:isReadOnly="isReadOnly"
                  v-bind:Id="'input_r_nameUnit'">                                     
               </MdEdit>
         </b-col> 
           <b-col lg="3" md="3" sm="12">
             <MdEdit 
                  v-bind:Label="$t('PatientClaimList.Charges')"
                  v-bind:TypeProp="'text'" 
                  v-bind:Name="'Name'"  
                  v-bind:MaxLengthProp="32"  
                  v-model="Claim.charges"
                  v-bind:isReadOnly="isReadOnly"
                  v-bind:Id="'input_r_nameCharges'">                                     
               </MdEdit>
         </b-col>
          <b-col lg="3" md="3" sm="12">
             <MdEdit 
                  v-bind:Label="$t('PatientClaimList.Paid')"
                  v-bind:TypeProp="'text'" 
                  v-bind:Name="'Name'"  
                  v-bind:MaxLengthProp="32"  
                  v-model="Claim.paid"
                  v-bind:isReadOnly="isReadOnly"
                  v-bind:Id="'input_r_namePaid'">                                     
               </MdEdit>
         </b-col>          
    </b-row>

    <b-row> 
       
         <b-col lg="3" md="3" sm="12">
            <MdLookup
                v-bind:ModelCode="Claim.valueCode"
                v-bind:ModelDescription="ValueCodeDescription"
                v-bind:Label="$t('PatientClaimList.ValueCode')"
                v-bind:RefCode="'ValueCodes'"                     
                v-bind:Api="'ValueCodes'"
                v-bind:FieldCode="'code'"                    
                v-bind:FieldDescription="'shortDescription'"
                :IsDisabled="isReadOnly" 
                :GetValues="onCodeConditionOk"   
                :SearchFieldCode="'code'"/>
         </b-col>   
         <b-col lg="3" md="3" sm="12">
             <MdEdit 
                  v-bind:Label="$t('PatientClaimList.AmountValCode')"
                  v-bind:TypeProp="'number'" 
                  v-bind:Name="'Name'"  
                  v-bind:MaxLengthProp="32"  
                  v-model="Claim.Amount"
                  v-bind:isReadOnly="isReadOnly"
                  v-bind:Id="'input_r_namePaid'">                                     
               </MdEdit>
         </b-col> 
        <b-col lg="3" md="3" sm="12">
            <MdButton
               v-bind:Label="$t('PatientClaimList.ModalOccAuthoCond')"
               v-bind:Name="'ClaimModalOccAuthoCond'"
               v-bind:ClassProp="'secondary btn-login mt-3'"
               v-on:click="OpenModalOccurAuthoCond"/>   
        </b-col>     
    </b-row>

     <MdTitle v-bind:Text="$t('PatientClaimList.PatientInformation')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

     <b-row>
         <b-col lg="3" md="3" sm="12">
            <MdLookup
                v-bind:ModelCode="Claim.primInsuranceNo"
                v-bind:ModelDescription="PrimInsuranceNoDescription"
                v-bind:Label="$t('PatientClaimList.PrimInsuranceNo')"
                v-bind:RefCode="'PrimaryInsurance'"                     
                v-bind:Api="'Insurances'"
                v-bind:FieldCode="'insurancecode'"                    
                v-bind:FieldDescription="'company'"
                :IsDisabled="isReadOnly"  
                :GetValues="onCodeConditionOk"  
                :SearchFieldCode="'code'"/>
         </b-col>   
         <b-col lg="3" md="3" sm="12">
            <MdLookup
                v-bind:ModelCode="Claim.SecInsuranceNo"
                v-bind:ModelDescription="SecInsuranceNoDescription"
                v-bind:Label="$t('PatientClaimList.SecInsuranceNo')"
                v-bind:RefCode="'SecInsurance'"                     
                v-bind:Api="'Insurances'"
                v-bind:FieldCode="'insurancecode'"                    
                v-bind:FieldDescription="'company'"
                :IsDisabled="isReadOnly" 
                :GetValues="onCodeConditionOk"  
                :SearchFieldCode="'code'"/>
         </b-col>   
           <b-col lg="3" md="3" sm="12">
            <MdLookup
                v-bind:ModelCode="Claim.TerInsuranceNo"
                v-bind:ModelDescription="TerInsuranceNoDescription"
                v-bind:Label="$t('PatientClaimList.TerInsuranceNo')"
                v-bind:RefCode="'TerInsurance'"                     
                v-bind:Api="'Insurances'"
                v-bind:FieldCode="'insurancecode'"                    
                v-bind:FieldDescription="'company'"
                :IsDisabled="isReadOnly"                  
                :GetValues="onCodeConditionOk"  
                :SearchFieldCode="'code'"/>
         </b-col>   
         <b-col lg="3" md="3" sm="12">
            <MdLookup
                v-bind:ModelCode="Claim.doctorCode"
                v-bind:ModelDescription="DoctorDescription"
                v-bind:Label="$t('PatientClaimList.Md')"
                v-bind:RefCode="'Doctors'"                     
                v-bind:Api="'Doctors'"
                v-bind:FieldCode="'code'"                    
                v-bind:FieldDescription="'name'"
                :IsDisabled="isReadOnly"  
                :GetValues="onCodeConditionOk"  
                :SearchFieldCode="'code'"/>
         </b-col>   
           
     </b-row>

     <b-row>
        <b-col lg="3" md="3" sm="12">
            <MdLookup
                v-bind:ModelCode="Claim.doctorCodeRef"
                v-bind:ModelDescription="DoctorCodeRefDescription"
                v-bind:Label="$t('PatientClaimList.RefMd')"
                v-bind:RefCode="'DoctorsRef'"                     
                v-bind:Api="'Doctors'"
                v-bind:FieldCode="'code'"                    
                v-bind:FieldDescription="'name'"
                :IsDisabled="isReadOnly" 
                :GetValues="onCodeConditionOk"  
                :SearchFieldCode="'code'"/>
         </b-col> 
          <b-col lg="3" md="3" sm="12">
            <MdLookup
                v-bind:ModelCode="Claim.facilityCode"
                v-bind:ModelDescription="FacilityDescription"
                v-bind:Label="$t('PatientClaimList.Facility')"
                v-bind:RefCode="'Facilities'"                     
                v-bind:Api="'Facilities'"
                v-bind:FieldCode="'code'"                    
                v-bind:FieldDescription="'company'"
                :IsDisabled="isReadOnly"  
                :GetValues="onCodeConditionOk"
                :SearchFieldCode="'code'"/>
         </b-col> 
         <b-col lg="3" md="3" sm="12">
             <MdEdit 
                  v-bind:Label="$t('PatientClaimList.Autho')"
                  v-bind:TypeProp="'number'" 
                  v-bind:Name="'Name'"  
                  v-bind:MaxLengthProp="32"  
                  v-model="Claim.autho"
                  v-bind:isReadOnly="isReadOnly"
                  v-bind:Id="'input_r_namePaid'">                                     
               </MdEdit>
         </b-col> 
         
          <b-col lg="3" md="3" sm="12">
             <MdEdit 
                  v-bind:Label="$t('PatientClaimList.PayReference')"
                  v-bind:TypeProp="'text'" 
                  v-bind:Name="'Name'"  
                  v-bind:MaxLengthProp="32"  
                  v-model="Claim.PayRef"
                  v-bind:isReadOnly="isReadOnly"
                  v-bind:Id="'input_r_namePaid'">                                     
               </MdEdit>
         </b-col>  
     </b-row>

     <b-row>
        <b-col lg="1" md="1" sm="12">
            <MdCheckBox
                v-bind:Label="$t('PatientClaimList.ApplyCr')"
                v-bind:Name="'checkbox-aplycr'"
                v-bind:ClassProp="'AlignCheck'"
                v-bind:CheckedValue="true"
                v-bind:UncheckedValue="false"
                v-model="ApplyCr" 
                v-bind:isReadOnly="isReadOnly"
                v-on:change="ChangeApplyCR"/>
          </b-col>
           <b-col lg="2" md="2" sm="12">
             <MdEdit 
                  v-bind:Label="$t('PatientClaimList.Credit')"
                  v-bind:TypeProp="'text'" 
                  v-bind:Name="'Name'"  
                  v-bind:MaxLengthProp="32"  
                  v-model="Claim.Credit"
                  v-bind:isReadOnly="true"
                  v-bind:Id="'input_r_nameCredit'">                                     
               </MdEdit>
         </b-col>  
         <b-col lg="3" md="3" sm="12">
            <MdSelect
                v-bind:Label="$t('PatientClaimList.PayType')"             
                v-bind:Options="PayTypeList"
                v-bind:FieldDescription="'name'"
                v-bind:FieldCode="'code'"
                v-bind:Model="Claim.PayType"                       
                v-bind:Multiple="false"
                v-bind:IsDisabled="isReadOnly"
                :Input="ChangeDropDownPayType"/>
        </b-col>
         <b-col lg="3" md="3" sm="12">
             <MdEdit 
                  v-bind:Label="$t('PatientClaimList.AmountPay')"
                  v-bind:TypeProp="'text'" 
                  v-bind:Name="'Name'"  
                  v-bind:MaxLengthProp="32"  
                  v-model="Claim.PayAmount"
                  v-bind:isReadOnly="isReadOnly"
                  v-bind:Id="'input_r_namePayAmount'">                                     
               </MdEdit>
         </b-col>  
     </b-row>
      <div class="space-actions"></div>
         <div class="page-actions">
        <MdButton
            v-bind:Label="$t('Shared.Back')"
            v-bind:Name="'btnpatientlist'"
            v-bind:ClassProp="'secondary mx-2 btn-login'"
            v-on:click="DiscardChanges"/>
            
        <MdButton
            v-bind:Label="$t('Shared.Save')"
            v-bind:ClassProp="(this.isReadOnly)?'primary mx-2':'primary btn-login mx-2'"
            v-on:click="ClickSaveCall"
            v-bind:isReadOnly="isReadOnly"
            v-bind:Name="'btn_save_contact'"/>
    </div>
     </div>   

    </div>


    <ModalClaimOccAuthoCondition
        v-if="showModalClaim"        
        v-bind:TitleWindow="$t('PatientClaimList.ModalOccAuthoCond')" 
        @OnResetModal="Reset($event)"
        @getCodeConditionOK="OnReturnOK($event)"
        @getCodeConditionCANCEL="OnReturnCancel($event)"
        v-bind:ModalId="'ModalIdClaimOcc'">
    </ModalClaimOccAuthoCondition>


        

 
</div>
</template>

<script>

import EnumService from '@/services/enum.service' 
//import { EventBus } from '@/event-bus.js';
import PatientService from '@/services/patient.service' 
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import Utils from '@/common/utils'
import Permission from '@/common/Permission'
import GlobalService from '@/services/global.service'
import moment from "moment";
import ClaimList from '@/services/claimlist.service';

export default {
  name: 'Claim',
  mixins: [ShowMessage, DBFunctions, Permission],
  data(){
    return{
        showModalClaim:false,
        PhotoObj:{},
        DiagList:[],
        Info:{},
        PayTypeList:[{code:"CHECK",name:"CHECK"},{code:"CASH",name:"CASH"},{code:"CREDIT",name:"CREDIT"},{code:"DEBIT",name:"DEBIT"}],
        ApplyCr:false,
        IssLineNoDescription:"",
        DocIndDescription:"",
        PosDescription:"",
        TosDescription:"",
        CPTREVCODEDescription:"",
        SuperBillDescription:"",
        DiagDescription:"",
        HCPCSDescription:"",
        FacilityDescription:"",
        TerInsuranceNoDescription:"",
        ValueCodeDescription:"",
        SecInsuranceNoDescription:"",
        DoctorDescription:"",
        DoctorCodeRefDescription:"",
        PrimInsuranceNoDescription:"",
        DateFrom:null,
        DateTo:null,
        Mode:this.$attrs.editMode,  
        isReadOnly:false,
        PatientTitle:{      
        programName:'',
        fullName:'',
        admitDate:'',
        dischargeDate:'',
        dob:'',
        activitytypename:'',
        startdatetime:'',
        ageFormatted:''
      },
        OptionsRightMenu:{
            visible:true,
            ItemsList:[],
            btnvisible:true,
            itemdisabled: false,
            PatientCode:''         
        },

       patient:{},


        Claim:{
            IssLineNo:"",
            DocInd:"",
            TosCode:"",
            PosCode:"",
            SuperBill:"",
            CPTREVCode:"",
            HCPCS:"",
            DiagCode:"",
            Day:"",
            Unit:"",
            Charges:"",
            Paid:"",
            ValueCode:"",
            Amount:0,
            PrimInsuranceNo:"",
            SecInsuranceNo:"",
            TerInsuranceNo:"",
            Md:"",
            RefMd:"",
            Facility:"",
            Autho:"",
            PayRef:"",
            Credit:"",
            PayType:"",
            PayAmount:"",
        }

    }
  },

  methods:{

  OpenModalOccurAuthoCond(){
    this.showModalClaim = true;
  },

  Reset(){
     this.showModalClaim = false;
  },

  OnReturnOK(){
    this.showModalClaim = false;
  },

  OnReturnCancel(){
    this.showModalClaim = false;
  },

    label(){

    },

    ChangeDropDownDiag(){

    },

    ChangeDropDownPayType(){

    },

    ChangeApplyCR(){

    },

    ClickSaveCall(){

    },

    getPatient() {  
            PatientService.get(this.$route.params.id)
            .then((response) => {
                if(response.status == '200' && response.data){
                    this.patient = response.data;

                    if(this.patient){
                        this.patient.sgDate = this.patient.sgDate ? Utils.formatterDateToString(this.patient.sgDate) : null;
                    }
                }                
            })
            .catch((error) => {
              if (!error.response) {              
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
              } else {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
              }           
            });  
        },


         getClaim() {  
             this.$emit("load", true);
            ClaimList.getClaim(this.$route.params.recId)
            .then((response) => {
                if(response.status == '200' && response.data){                    
                    this.Claim = response.data;     
                   
                    this.DateFrom = this.Claim.dateFrom ? moment(this.Claim.dateFrom).format('YYYY-MM-DD') : null;
                    this.DateTo = this.Claim.dateTo ? moment(this.Claim.dateTo).format('YYYY-MM-DD') : null;  
                    this.PosDescription = this.Claim.posDescription; 
                    this.HCPCSDescription = this.Claim.hcpcsDescription;      
                    this.DoctorDescription = this.Claim.doctorDescription;   
                    this.PrimInsuranceNoDescription = this.Claim.primInsuranceNoDescription;
                    this.DoctorCodeRefDescription = this.Claim.doctorCodeRefDescription;
                    this.FacilityDescription =  this.Claim.facilityDescription;
                }   
                this.$emit("load", false);             
            })
            .catch((error) => {
                this.$emit("load", false); 
              if (!error.response) {              
                this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
              } else {
                this.showMessage(this.$tc('Msg.Error'),error,"error");
              }           
            });  
        },

    DiscardChanges(){
        this.$router.push({ name: 'patientclaimList', params: { id: this.$route.params.id }});
    },

    onCodeConditionOk(){

    },

       async getDateTime() { 
         await GlobalService.getDateTime()
            .then((response) => {      
               if (response.data) {                                  
                    this.DateFrom = moment(response.data).format('YYYY-MM-DD');
                    this.DateTo = moment(response.data).format('YYYY-MM-DD');                  
               }  
         })
         .catch(error => {
            if (error.response) {
               this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
         }); 
      },

      async GetVisitDiagnosisCodes() { 
         await ClaimList.GetVisitDiagnosisCodes(this.$route.params.id,null)
            .then((response) => {      
               if (response.data) {                                  
                   this.DiagList = response.data;            
               }  
         })
         .catch(error => {
            if (error.response) {
               this.showMessage(this.$tc('Msg.Error'),error,"error");
            }
         }); 
      },

     async GetPatientByCode(){
      var infoList = await this.getInfoTitle(this.$route.params.id);
      if(infoList.length > 0){
        this.PatientTitle.programName = '';
        this.PatientTitle.admitDate = '';
        this.PatientTitle.dischargeDate = '';

        const { dob, firstname, lastname, age, ageFormatted } = infoList[0]; // Destructure for easier access

        if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
        if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
        if (age) this.PatientTitle.age = age;
        if (firstname) this.PatientTitle.fullName = firstname + ' '+ lastname;     
      }
    },
  },

  created(){
     this.GetVisitDiagnosisCodes();
  },

  async mounted(){
    this.OptionsRightMenu.ItemsList = EnumService.PatientItems;
    this.OptionsRightMenu.visible = true;
    this.$emit("getVisibleMenu", this.OptionsRightMenu);  
    this.isReadOnly = await this.$store.state.isPatientClaimsEHRReadOnly;  
    await this.GetPatientByCode();
    this.getPatient();
    await this.getDateTime();
    if(this.$attrs.editMode){
         this.getClaim();
    }
   

  }
   
};
</script>


